module.exports = __webpack_public_path__ + "fonts/ClearSans-Regular-webfontfb59f92c59ee1363b6c80e4fbd9b267e.ttf";